import { RefreshCw } from 'lucide-react'

import type { QueryView } from '@krp/client-runtime'
import { Button, StatusMessage } from '@krp/ui-kit'

import type { AqsiDiagnosticsActions, AqsiDiagnosticsVm } from '../model/types'
import '../../../shared/ui/aqsi.css'

function Failure({ title, query, onRetry }: { title: string; query: QueryView; onRetry: () => void }) {
  if (query.status === 'loading' || query.status === 'idle') return <StatusMessage kind="loading" title={`${title}…`} />
  const error = query.error
  const kind = query.status === 'forbidden' ? 'forbidden' : query.status === 'unavailable' ? 'unavailable' : 'error'
  return (
    <StatusMessage
      kind={kind}
      title={`${title}: не получено`}
      text={error?.message}
      {...(error !== null && error.correlationId !== null
        ? { meta: `Код: ${error.code} · запрос ${error.correlationId}` }
        : {})}
      action={
        <Button variant="secondary" icon={<RefreshCw size={16} aria-hidden="true" />} onClick={onRetry}>
          Повторить
        </Button>
      }
    />
  )
}

/** Диагностика кабинета AQSI: профиль без ключа. Ключ кабинета сюда не приходит. */
export function AqsiDiagnosticsPanel({ vm, actions }: { vm: AqsiDiagnosticsVm; actions: AqsiDiagnosticsActions }) {
  return (
    <div className="aqsi-diagnostics">
      {vm.profile.value === null ? (
        <Failure title="Профиль кабинета" query={vm.profile.query} onRetry={actions.reload} />
      ) : (
        <dl>
          <dt>Магазин в кабинете</dt>
          <dd>{vm.profile.value.shopId}</dd>
          <dt>Ревизия настроек</dt>
          <dd>{vm.profile.value.configurationVersion}</dd>
          <dt>Права службы</dt>
          <dd>{vm.profile.value.capabilities.join(', ') || 'нет'}</dd>
        </dl>
      )}
    </div>
  )
}
